module.exports = __webpack_public_path__ + "img/hr-stack-inserter-platform.5c1952cc.png";